import React from 'react';
import { Alert, AlertTitle, cn } from 'homebox-ui';
import { MdCheck, MdClose } from 'react-icons/md';
import { toast } from 'react-hot-toast';

export function AlertSuccess({ title, currentToast, isClosable = true }) {
  return (
    <>
      <Alert
        className={cn(
          `flex max-w-sm items-center justify-between transition-all duration-100`,
          currentToast?.visible ? 'animate-enter' : 'animate-leave'
        )}
        variant='success'
      >
        <div className='flex items-center space-x-3'>
          <div className='border-success-300 flex h-10 w-10 items-center justify-center rounded-full border p-3'>
            <MdCheck className='h-4 w-4' />
          </div>
          <AlertTitle>{title}</AlertTitle>
        </div>
        {isClosable && (
          <button
            className='cursor-pointer rounded-none border border-transparent px-6 py-3'
            type='button'
            onClick={() => toast.dismiss(currentToast?.id)}
          >
            <MdClose className='text-success-800 h-4 w-4 cursor-pointer' />
          </button>
        )}
      </Alert>
    </>
  );
}
